export const formatTime = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
};

export const getSecondsDifference = (timestamp) => {
  const givenTime = new Date(timestamp); // Convert the timestamp to a Date object
  const now = new Date(); // Get the current time
  const differenceInSeconds = Math.abs((now - givenTime) / 1000); // Calculate difference in seconds
  return Math.floor(differenceInSeconds); // Return whole seconds
};
